var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#3B3D4B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.4304,
    y: 9.56952,
    width: 3.41773,
    height: 19.2997,
    rx: 1.70887,
    fill: "#BEDFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.56964,
    y: 20.8479,
    width: 3.41773,
    height: 19.2997,
    rx: 1.70887,
    transform: "rotate(-90 9.56964 20.8479)",
    fill: "#BEDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusbutton);
export default __webpack_public_path__ + "static/media/plusbutton.936294eb40d1e3ae1b63ff51d8af2dfb.svg";
export { ForwardRef as ReactComponent };